import * as React from "react";
import { useCallback, useMemo } from "react";
import { styled } from "styled-components";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import ReportQueryHelper from "report/report-history-page/ReportHistoryQueryHelper";
import { STATUS_LABELS } from "report/report-history-page/StatusCell";
import fetchReportHistory from "./fetchReportHistory";
import ReportHistoryActions from "./ReportHistoryActions";
import customColumnRenderers from "./ColumnRenderers";
const DEFAULT_DISPLAYED_ATTRIBUTES = ["generated_at", "status", "recipients", "has_asset", "message"];
const TABLE_LAYOUT = {
  defaultColumnOrder: DEFAULT_DISPLAYED_ATTRIBUTES,
  defaultDisplayedAttributes: DEFAULT_DISPLAYED_ATTRIBUTES,
  defaultPageSize: 20,
  defaultSort: { attributeId: "generated_at", direction: "desc" },
  entityTableId: "reports_history"
};
const additionalAttributes = [{ id: "recipients", title: "Recipients", sortable: false }];
const fetchOptions = { refetchInterval: 2e3 };
const FilterValueRenderers = {
  status: (value) => {
    var _a;
    return (_a = STATUS_LABELS[value]) != null ? _a : value;
  }
};
const Table = styled.div`
  display: flex;
  gap: 50px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;
const Label = styled.span`
  font-weight: 300;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const GrowColumn = styled(Column)`
  flex-grow: 1;
`;
const Recipient = styled.div``;
const NoRecipients = styled.i`
  white-space: nowrap;
`;
const MessageDetails = styled.pre`
  white-space: pre-wrap;
  word-break: break-word;
`;
const expandedSections = {
  details: {
    title: "Details",
    content: (history) => {
      var _a, _b;
      return /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(Column, null, /* @__PURE__ */ React.createElement(Label, null, "Recipients"), ((_a = history.recipients) == null ? void 0 : _a.length) ? (_b = history.recipients) == null ? void 0 : _b.map((recipient) => /* @__PURE__ */ React.createElement(Recipient, { key: recipient }, recipient)) : /* @__PURE__ */ React.createElement(NoRecipients, null, "No recipients configured")), /* @__PURE__ */ React.createElement(GrowColumn, null, /* @__PURE__ */ React.createElement(Label, null, "Message Details"), history.message ? /* @__PURE__ */ React.createElement(MessageDetails, null, history.message) : /* @__PURE__ */ React.createElement("i", null, "No further message.")));
    },
    disableHeader: true
  }
};
const ReportHistoryList = ({ id: reportId, editAllowed }) => {
  const keyFn = useCallback((searchParams) => ["reports", "history", reportId, searchParams], [reportId]);
  const _fetchReportHistory = useCallback(
    (searchParams) => fetchReportHistory(reportId, searchParams),
    [reportId]
  );
  const entityActions = useCallback(
    (listItem) => /* @__PURE__ */ React.createElement(ReportHistoryActions, { id: reportId, reportHistory: listItem, disabled: !editAllowed }),
    [reportId, editAllowed]
  );
  const _customColumnRenderers = useMemo(() => customColumnRenderers(reportId), [reportId]);
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "report archive",
      queryHelpComponent: /* @__PURE__ */ React.createElement(ReportQueryHelper, null),
      entityActions,
      tableLayout: TABLE_LAYOUT,
      fetchEntities: _fetchReportHistory,
      expandedSectionRenderers: expandedSections,
      fetchOptions,
      filterValueRenderers: FilterValueRenderers,
      entityAttributesAreCamelCase: false,
      keyFn,
      additionalAttributes,
      columnRenderers: _customColumnRenderers
    }
  );
};
export default ReportHistoryList;
